// @flow
import * as materialAppearance from './material'
import type { Styles } from '..'

const isFieldActive = (props: Styles) =>
  props.$focus || props.$nonEmpty || props.$disableFloatingLabel

export const Label = (props: Styles) => {
  const leftMargin = props.$hasPrefix ? '30px' : '0px'
  const rightMargin = props.$hasPrefix ? '46px' : '16px'
  const activeStyles = !isFieldActive(props)
    ? {
        transform: `scale(1) translate3d(${leftMargin}, 50%, 0px)`,
        right: rightMargin,
      }
    : {
        transform: 'translate3d(0, 2px, 0px) scale(0.75)',
        right: '-26px',
      }

  return {
    ...materialAppearance.Label(props),
    ...activeStyles,
    fontSize: '18px',
    width: 'auto',
    left: '16px',
    top: '0',
  }
}

export const InputWrapper = (props: Styles) => ({
  ...materialAppearance.InputWrapper(props),
  padding: '4px 5px 3px 16px',
})

export const Content = ({ $palette }: Styles) => {
  return {
    ...materialAppearance.Content,
    borderLeft: `1px solid ${$palette('gray')}`,
    borderTop: `1px solid ${$palette('gray')}`,
    borderRight: `1px solid ${$palette('gray')}`,
  }
}

export const PrefixWrapper = (props: Styles) => ({
  ...materialAppearance.PrefixWrapper(props),
  fontSize: '20px',
  transition: `transform ${materialAppearance.DEFAULT_ANIMATION}`,
  transform: isFieldActive(props)
    ? `scale(0.8) translate3d(-1px, 0px, 0px)`
    : `scale(1) translate3d(0px, -9px, 0px)`,
})
